import angular from 'angular';
import controller from './button.controller';
import template from './button.html';
import ButtonComponent from './button.component';

const buttonConfig = /* @ngInject */ (
	/** @type {any} */ KformComponentsProvider,
	/** @type {any} */ FORM_OPTIONS,
) => {
	KformComponentsProvider.register('button', {
		title: 'Button',
		template,
		children:   false,
		selectable: true,
		settings: new ButtonComponent(),
		controller,
		onEdit: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.actions = FORM_OPTIONS.actions;
			$scope.sizes = FORM_OPTIONS.sizes;
			$scope.themes = FORM_OPTIONS.themes;
		},
		icon:          'fa fa-stop',
		views:         [
			{
				name:     'Display',
				template: 'kform/components/button/display.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
	});
};

export default angular.module('app').config(buttonConfig);
